var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9d8f8f",
    fillRule: "evenodd",
    d: "M13.395 1.324a3.162 3.162 0 0 0-2.79 0l-8.752 4.31c-1.137.56-1.137 2.173 0 2.733l8.752 4.309a3.161 3.161 0 0 0 2.79 0l8.752-4.31c1.137-.56 1.137-2.173 0-2.733zM1.903 10.61a.5.5 0 0 1 .442 0l8.26 4.067a3.162 3.162 0 0 0 2.79 0l8.26-4.067a.5.5 0 0 1 .442 0l.05.024c1.137.56 1.137 2.174 0 2.733l-8.752 4.31a3.162 3.162 0 0 1-2.79 0l-8.752-4.31c-1.137-.56-1.137-2.173 0-2.733zm.442 5a.5.5 0 0 0-.442 0l-.05.025c-1.137.56-1.137 2.173 0 2.733l8.752 4.309a3.162 3.162 0 0 0 2.79 0l8.752-4.31c1.137-.56 1.137-2.173 0-2.733l-.05-.024a.5.5 0 0 0-.442 0l-8.26 4.067a3.162 3.162 0 0 1-2.79 0z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.62ea931a0866f5dbb02103917e174f8d.svg";
export { ForwardRef as ReactComponent };